export type CategoryRow = { id: string; name: string; slug: string; parentId: string | null };

export function buildCategorySelectOptions(categories: CategoryRow[]) {
  const byId = new Map(categories.map((c) => [c.id, c]));
  const cache = new Map<string, string>();
  function pathFor(id: string): string {
    const hit = cache.get(id);
    if (hit) return hit;
    const c = byId.get(id);
    if (!c) return "";
    const label = c.parentId ? `${pathFor(c.parentId)} › ${c.name}` : c.name;
    cache.set(id, label);
    return label;
  }
  return categories
    .map((c) => ({
      value: c.id,
      label: pathFor(c.id),
      hint: c.slug,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
